// OthersInSet.js
import React from 'react';
import config from '../../utils/config.js';
import { Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { connect } from 'react-redux';
import { has, isEmpty } from 'lodash';
import { chunk } from '../../utils/utilities';
import { users } from '../../store/actions';
import { getTemplates, displayMore } from '../../utils/apputils';
import Spinner from '../Spinner/Spinner.js';
import { productView } from '../../utils/google';

class OthersInSet_Class extends React.Component {
  componentDidMount() {
    const { dispatch } = this.props;
    getTemplates(dispatch);
  }

  displayMore = () => {
    const { dispatch } = this.props;
    displayMore(dispatch, 'setMoreButton');
  };

  render() {
    const {
      templateSets,
      template_key,
      templates,
      imageCount,
      displayCountStatus
    } = this.props;
    const matchingTemplates = [];
    const templateSet = templateSets
      ? templateSets.find(x => x.templates.includes(template_key))
      : [];
    if (has(templateSet, 'templates')) {
      const otherTemplatesIDs = templateSet.templates.filter(
        x => x !== template_key
      );
      otherTemplatesIDs.map(id =>
        matchingTemplates.push({ id: id, properties: templates[id] })
      );
    }
    const otherTemplatesToRender = matchingTemplates.map((template, index) => {
      const angle = Math.floor(Math.random() * (11 - 5) + 5);
      return (
        <SetEntry
          name={template.properties.name}
          description={template.properties.description}
          key={template.id}
          image={template.id}
          per_row={3}
          angle={`${'+-'[index % 2]}${angle}`}
          className="card"
        />
      );
    });

    if (!isEmpty(otherTemplatesToRender)) {
      return (
        <div className="container">
          <h2 className="grid-title">Why not try another one?</h2>
          {chunk(otherTemplatesToRender.slice(0, imageCount), 3).map(
            (part, index) => {
              return (
                <div className="row" key={index}>
                  {part}
                </div>
              );
            }
          )}
          <div className="pagination">
            <button
              id="set-more-button"
              className="btn btn-secondary btn-bevel"
              onClick={this.displayMore}
              disabled={otherTemplatesToRender.length <= imageCount}
            >
              {displayCountStatus !== users.types.DISPLAYING_MORE && (
                <span>More</span>
              )}
              {displayCountStatus === users.types.DISPLAYING_MORE && (
                <Spinner type="moreButton" />
              )}
            </button>
          </div>
        </div>
      );
    } else {
      return <div />;
    }
  }
}

const SetEntry = ({ per_row, image, angle, name, description }) => (
  <Col xs={12 / per_row}>
    <LinkContainer
      className="card"
      to={'/feature/' + image}
      style={{ transform: `rotate(${angle}deg)` }}
      onClick={() => productView(image)}
    >
      <div>
        <h3 className="card-title">{name}</h3>
        <div className="card-img">
          <img
            src={`https://s3.${config.region}.amazonaws.com/${
              config.TemplateBucket
            }/${image}_thumbnail`}
            className="home-thumbnail"
            width="310"
            alt=""
          />
        </div>
        <p className="card-desc">{description}</p>
        <button className="card-cta btn btn-bevel">Personalise it now!</button>
      </div>
    </LinkContainer>
  </Col>
);

const mapStateToProps = state => ({
  templates: state.s3Templates.templatesJSON.templates,
  template_key: state.uploads.template_key,
  templateSets: state.s3Templates.templatesJSON.sets,
  imageCount: state.users.setDisplayCount,
  displayCountStatus: state.users.displayCountStatus
});
export const OthersInSet = connect(mapStateToProps)(OthersInSet_Class);



// WEBPACK FOOTER //
// ./src/comps/Feature/OthersInSet.js